export const listDataGasCompositionData = [
  {
    Id: "1",
    CompositionGas: "ERW",
    N2: "",
    CO2: "",
    C1: "",
    C2: "",
    C3: "",
    IC4: "",
    NC5: "",
    IC4: "",
    NC4: "",
    IC5: "",
    NC5: "",
    C6: "",
    C7: "",
    Total: "",
  },
  {
    Id: "2",
    CompositionGas: "BPT",
    N2: "",
    CO2: "",
    C1: "",
    C2: "",
    C3: "",
    IC4: "",
    NC5: "",
    IC4: "",
    NC4: "",
    IC5: "",
    NC5: "",
    C6: "",
    C7: "",
    Total: "",
  },
  {
    Id: "3",
    CompositionGas: "STN",
    N2: "",
    CO2: "",
    C1: "",
    C2: "",
    C3: "",
    IC4: "",
    NC5: "",
    IC4: "",
    NC4: "",
    IC5: "",
    NC5: "",
    C6: "",
    C7: "",
    Total: "",
  },
  {
    Id: "4",
    CompositionGas: "FUN",
    N2: "",
    CO2: "",
    C1: "",
    C2: "",
    C3: "",
    IC4: "",
    NC5: "",
    IC4: "",
    NC4: "",
    IC5: "",
    NC5: "",
    C6: "",
    C7: "",
    Total: "",
  },
  {
    Id: "5",
    CompositionGas: "PLT",
    N2: "",
    CO2: "",
    C1: "",
    C2: "",
    C3: "",
    IC4: "",
    NC5: "",
    IC4: "",
    NC4: "",
    IC5: "",
    NC5: "",
    C6: "",
    C7: "",
    Total: "",
  },
  {
    Id: "6",
    CompositionGas: "GBN",
    N2: "",
    CO2: "",
    C1: "",
    C2: "",
    C3: "",
    IC4: "",
    NC5: "",
    IC4: "",
    NC4: "",
    IC5: "",
    NC5: "",
    C6: "",
    C7: "",
    Total: "",
  },
  {
    Id: "7",
    CompositionGas: "S.Pailin",
    N2: "",
    CO2: "",
    C1: "",
    C2: "",
    C3: "",
    IC4: "",
    NC5: "",
    IC4: "",
    NC4: "",
    IC5: "",
    NC5: "",
    C6: "",
    C7: "",
    Total: "",
  },
  {
    Id: "8",
    CompositionGas: "N'Pailin",
    N2: "",
    CO2: "",
    C1: "",
    C2: "",
    C3: "",
    IC4: "",
    NC5: "",
    IC4: "",
    NC4: "",
    IC5: "",
    NC5: "",
    C6: "",
    C7: "",
    Total: "",
  },
  {
    Id: "9",
    CompositionGas: "BEN",
    N2: "",
    CO2: "",
    C1: "",
    C2: "",
    C3: "",
    IC4: "",
    NC5: "",
    IC4: "",
    NC4: "",
    IC5: "",
    NC5: "",
    C6: "",
    C7: "",
    Total: "",
  },
  {
    Id: "10",
    CompositionGas: "ART",
    N2: "",
    CO2: "",
    C1: "",
    C2: "",
    C3: "",
    IC4: "",
    NC5: "",
    IC4: "",
    NC4: "",
    IC5: "",
    NC5: "",
    C6: "",
    C7: "",
    Total: "",
  },
  {
    Id: "11",
    CompositionGas: "GBS",
    N2: "",
    CO2: "",
    C1: "",
    C2: "",
    C3: "",
    IC4: "",
    NC5: "",
    IC4: "",
    NC4: "",
    IC5: "",
    NC5: "",
    C6: "",
    C7: "",
    Total: "",
  },
  {
    Id: "12",
    CompositionGas: "JDA-A18 DP2",
    N2: "",
    CO2: "",
    C1: "",
    C2: "",
    C3: "",
    IC4: "",
    NC5: "",
    IC4: "",
    NC4: "",
    IC5: "",
    NC5: "",
    C6: "",
    C7: "",
    Total: "",
  },
  {
    Id: "13",
    CompositionGas: "JDA-B17",
    N2: "",
    CO2: "",
    C1: "",
    C2: "",
    C3: "",
    IC4: "",
    NC5: "",
    IC4: "",
    NC4: "",
    IC5: "",
    NC5: "",
    C6: "",
    C7: "",
    Total: "",
  },
  {
    Id: "14",
    CompositionGas: "PLATONG2",
    N2: "",
    CO2: "",
    C1: "",
    C2: "",
    C3: "",
    IC4: "",
    NC5: "",
    IC4: "",
    NC4: "",
    IC5: "",
    NC5: "",
    C6: "",
    C7: "",
    Total: "",
  },
];

//headerColumn
export const columnsGasCompositionData = [
  {
    dataField: "CompositionGas",
    text: "COMPOSITION GAS",
    headerAlign: "center",
    editable: false,
    align: "center",
    style: (cell, row, rowIndex, colIndex) => {
      return {
        color: "#FFFFFF",
        backgroundColor:"#6478D7",
        fontWeight: "600",
      };
    },
    headerStyle: {
      backgroundColor: "#7e8eda",
      // width: "3%",
    },
  },
  {
    dataField: "N2",
    text: "N2",
    headerAlign: "center",
    editable: false,
    align: "center",
    headerStyle: {
      backgroundColor: "#6478D7",
      // width: "3%",
    },
  },
  {
    dataField: "CO2",
    text: "CO2",
    headerAlign: "center",
    editable: false,
    align: "center",
    headerStyle: {
      backgroundColor: "#6478D7",
      // width: "3%",
    },
  },

  {
    dataField: "C1",
    text: "C1",
    headerAlign: "center",
    editable: false,
    align: "center",
    headerStyle: {
      backgroundColor: "#6478D7",
      // width: "3%",
    },
  },
  {
    dataField: "C2",
    text: "C2",
    headerAlign: "center",
    editable: false,
    align: "center",
    headerStyle: {
      backgroundColor: "#556ee6",
      // width: "3%",
    },
  },
  {
    dataField: "C3",
    text: "C3",
    headerAlign: "center",
    editable: false,
    align: "center",
    headerStyle: {
      backgroundColor: "#556ee6",
      // width: "3%",
    },
  },
  {
    dataField: "IC4",
    text: "IC4",
    headerAlign: "center",
    editable: false,
    align: "center",
    headerStyle: {
      backgroundColor: "#556ee6",
      // width: "3%",
    },
  },
  {
    dataField: "NC5",
    text: "NC5",
    headerAlign: "center",
    editable: false,
    align: "center",
    headerStyle: {
      backgroundColor: "#556ee6",
      // width: "3%",
    },
  },
  {
    dataField: "IC4",
    text: "IC4",
    headerAlign: "center",
    editable: false,
    align: "center",
    headerStyle: {
      backgroundColor: "#556ee6",
      // width: "3%",
    },
  },
  {
    dataField: "NC4",
    text: "NC4",
    headerAlign: "center",
    editable: false,
    align: "center",
    headerStyle: {
      backgroundColor: "#556ee6",
      // width: "3%",
    },
  },
  {
    dataField: "IC5",
    text: "IC5",
    headerAlign: "center",
    editable: false,
    align: "center",
    headerStyle: {
      backgroundColor: "#556ee6",
      // width: "3%",
    },
  },
  {
    dataField: "NC5",
    text: "NC5",
    headerAlign: "center",
    editable: false,
    align: "center",
    headerStyle: {
      backgroundColor: "#556ee6",
      // width: "3%",
    },
  },
  {
    dataField: "C6",
    text: "C6",
    headerAlign: "center",
    editable: false,
    align: "center",
    headerStyle: {
      backgroundColor: "#556ee6",
      // width: "3%",
    },
  },
  {
    dataField: "C7",
    text: "C7+",
    headerAlign: "center",
    editable: false,
    align: "center",
    headerStyle: {
      backgroundColor: "#556ee6",
      // width: "3%",
    },
  },
  {
    dataField: "Total",
    text: "Total",
    headerAlign: "center",
    editable: false,
    align: "center",
    headerStyle: {
      backgroundColor: "#556ee6",
      // width: "3%",
    },
  },
];
